import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './components/Button';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} data-id="element-0">
    {children}
  </motion.div>;
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', '790333870788238');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-pink selection:text-white pb-20" data-id="element-1">
      {/* TOP ANNOUNCEMENT BAR */}
      <div className="bg-brand-navy text-white text-center py-2 px-4 text-sm font-medium w-full" data-id="element-2">
        ⚽ Megapack Mundial 2026 · Material listo para toda la escuela
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-4" data-id="element-3">
        {/* 1. HERO SECTION */}
        <section className="text-center mb-12" data-id="element-4">
          <FadeIn data-id="element-5">
            <p className="text-brand-gray sm:text-base mb-2 font-medium text-[12px]" data-id="element-6">
              "El recurso educativo más completo para trabajar el Mundial 2026
              en la escuela"
            </p>
            <h1 className="sm:text-4xl md:text-5xl font-black text-brand-pink mb-4 text-[24px]" data-id="element-7">
              ⚽ MEGAPACK MUNDIAL 2026
            </h1>
            <h2 className="sm:text-2xl font-bold text-brand-navy mb-8 text-[18px]" data-id="element-8">
              Todo el material organizado, listo para usar y adaptado a cada
              nivel
            </h2>

            <div className="relative w-full mb-8" data-id="element-9">
              <img src="https://cdn.magicpatterns.com/uploads/iN3v9qG2kic5HxeUHJqiJh/imagen_principal.png" alt="Megapack Mundial 2026 - Todo el material que necesitás" className="w-full" data-id="element-10" />
            </div>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-left" data-id="element-11">
              <h3 className="font-bold text-lg sm:text-xl mb-6 text-center text-brand-navy" data-id="element-12">
                👉 Acceso inmediato y organizado
              </h3>
              <ul className="space-y-4" data-id="element-13">
                {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material organizado', 'Descargás e imprimís cuando quieras'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-base sm:text-lg" data-id="element-14">
                    <span className="mr-3 text-xl text-green-500" data-id="element-15">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 2. PREGUNTA BLOCK */}
        <section className="text-center mb-12" data-id="element-16">
          <FadeIn data-id="element-17">
            <p className="text-lg mb-4 font-[600] text-[#2A512E]" data-id="element-18">
              Si sos docente, dejame hacerte una pregunta honesta:
            </p>
            <h2 className="sm:text-3xl font-bold mb-6 text-[20px] text-[#2E9E3D]" data-id="element-19">
              ¿Te gustaría aprovechar el Mundial 2026 para enseñar... pero
              sentís que armar todo el material te lleva demasiado tiempo?
            </h2>
            <div className="space-y-4 text-base sm:text-lg text-brand-navy max-w-2xl mx-auto" data-id="element-20">
              <p data-id="element-21">Porque trabajar el Mundial en la escuela suele significar:</p>
              <ul className="text-left max-w-md mx-auto space-y-2" data-id="element-22">
                <li data-id="element-23">• Buscar actividades en muchos lugares</li>
                <li data-id="element-24">• Adaptarlas para distintas edades</li>
                <li data-id="element-25">• Pensar propuestas para varias materias</li>
                <li data-id="element-26">• Preparar recursos para diferentes cursos</li>
                <li data-id="element-27">• Empezar siempre desde cero</li>
              </ul>
              <p className="font-bold text-xl mt-6" data-id="element-28">
                Y mientras tanto... seguís planificando durante horas.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 3. PROBLEMA BLOCK */}
        <section className="text-center mb-12" data-id="element-29">
          <FadeIn data-id="element-30">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-[#2E9E3D]" data-id="element-31">
              Trabajar el Mundial en clase no debería ser tan difícil
            </h2>
            <p className="text-base sm:text-lg text-brand-navy mb-6" data-id="element-32">
              El problema que muchos docentes viven todos los años:
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-33">
              <ul className="space-y-4" data-id="element-34">
                {['No encuentran material completo', 'Las actividades son muy básicas', 'Todo está disperso', 'Falta material para diferentes edades', 'No hay propuestas inclusivas', 'Terminan improvisando'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base sm:text-lg" data-id="element-35">
                    <span className="mr-3 text-brand-red font-bold text-xl" data-id="element-36">
                      •
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-xl sm:text-2xl font-bold text-brand-navy" data-id="element-37">
              Podrías aprovechar mucho más el Mundial... si tuvieras todo listo.
            </p>
          </FadeIn>
        </section>

        {/* 4. SOLUCIÓN BLOCK */}
        <section className="text-center mb-12" data-id="element-38">
          <FadeIn data-id="element-39">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-40">
              La solución: Megapack Mundial 2026
            </h2>

            <div className="max-w-xs mx-auto mb-8" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/x4mQToS3bFPCEfjtifH8fc/mockup_principal.png" alt="Megapack Mundial 2026" className="w-full" data-id="element-42" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-43">
              Un sistema completo para trabajar el Mundial en toda la escuela.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-10" data-id="element-44">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-lg font-bold text-brand-navy" data-id="element-45">
                <div className="flex items-center" data-id="element-46">
                  <span className="text-2xl mr-2" data-id="element-47">📂</span> Elegís el material
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-48">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-49">⬇</span>
                <div className="flex items-center" data-id="element-50">
                  <span className="text-2xl mr-2" data-id="element-51">📖</span> Imprimís o utilizás
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-52">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-53">⬇</span>
                <div className="flex items-center text-brand-pink" data-id="element-54">
                  <span className="text-2xl mr-2" data-id="element-55">⚽</span> Aplicás las
                  actividades
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-10 font-bold text-brand-navy text-lg flex-wrap" data-id="element-56">
              <div className="font-[400]" data-id="element-57">
                <span className="text-green-500 mr-1" data-id="element-58">✔</span>Sin perder tiempo
              </div>
              <div className="font-[400]" data-id="element-59">
                <span className="text-green-500 mr-1" data-id="element-60">✔</span>Sin buscar
                recursos
              </div>
              <div className="font-[400]" data-id="element-61">
                <span className="text-green-500 mr-1" data-id="element-62">✔</span>Sin empezar desde
                cero
              </div>
              <div className="font-[400]" data-id="element-63">
                <span className="text-green-500 mr-1" data-id="element-64">✔</span>Sin improvisar
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 5. CONTENIDO BLOCK */}
        <section className="text-center mb-12" data-id="element-65">
          <FadeIn data-id="element-66">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-10" data-id="element-67">
              ¿Qué incluye el Megapack Mundial 2026?
            </h2>

            <div className="space-y-8 max-w-xl mx-auto text-left" data-id="element-68">
              {/* Bloque 1 - Primer Ciclo */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-69">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-70">
                  🌎 RUMBO AL MUNDIAL 2026 — PRIMER CICLO
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-71">
                  Para 1°, 2° y 3° grado
                </p>
                <ul className="space-y-3" data-id="element-72">
                  {['Lengua', 'Matemática', 'Ciencias Sociales', 'Actividades mundialistas', 'Comprensión lectora', 'Pasaporte mundialista'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-73">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-74">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-75">
                  💡 Ideal para aprender jugando y descubrir el mundo del
                  fútbol.
                </p>
              </div>

              {/* Bloque 2 - Segundo Ciclo */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-76">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-77">
                  🌎 RUMBO AL MUNDIAL 2026 — SEGUNDO CICLO
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-78">
                  Para 4°, 5° y 6° grado
                </p>
                <ul className="space-y-3" data-id="element-79">
                  {['Lengua', 'Matemática', 'Ciencias Sociales', 'Ciencias Naturales', 'Tablas', 'Gráficos', 'Estadísticas', 'Producción escrita'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-80">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-81">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-82">
                  💡 Los estudiantes analizan, investigan y aprenden a partir
                  del Mundial.
                </p>
              </div>

              {/* Bloque 3 - Inclusión */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-83">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-84">
                  🌎 RUMBO AL MUNDIAL 2026 — ESPECIAL INCLUSIÓN
                </h3>
                <ul className="space-y-3 mt-5" data-id="element-85">
                  {['Actividades adaptadas', 'Imprenta mayúscula', 'Letra grande', 'Menor carga visual', 'Consignas simples', 'Mayor accesibilidad'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-86">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-87">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-88">
                  💡 Para que todos los estudiantes puedan participar del viaje
                  mundialista.
                </p>
              </div>

              {/* Bloque 4 - Pack Docentes */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-89">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-90">
                  👩‍🏫 PACK MUNDIAL PARA DOCENTES
                </h3>
                <ul className="space-y-3 mt-5" data-id="element-91">
                  {['Historia del Mundial', 'Países anfitriones', 'Ciudades sede', 'Jugadores históricos', 'Valores del deporte', 'Propuestas para el aula'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-92">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-93">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-94">
                  💡 Todo el contexto necesario para enriquecer tus clases.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* ÁREAS CURRICULARES */}
        <section className="text-center mb-12" data-id="element-95">
          <FadeIn data-id="element-96">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-3" data-id="element-97">
              ⚽ Trabajá todas las áreas curriculares
            </h2>
            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto" data-id="element-98">
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6" data-id="element-99">
                {[{
                icon: '📚',
                label: 'Lengua'
              }, {
                icon: '🔢',
                label: 'Matemática'
              }, {
                icon: '🌎',
                label: 'Ciencias Sociales'
              }, {
                icon: '🔬',
                label: 'Ciencias Naturales'
              }, {
                icon: '🤝',
                label: 'Inclusión Educativa'
              }].map((item, i) => <div key={i} className="bg-white rounded-xl p-4 flex flex-col items-center justify-center" data-id="element-100">
                    <span className="text-3xl mb-2" data-id="element-101">{item.icon}</span>
                    <span className="text-sm font-bold text-brand-navy text-center" data-id="element-102">
                      {item.label}
                    </span>
                  </div>)}
              </div>
              <p className="text-brand-navy text-sm sm:text-base" data-id="element-103">
                Todo a través de una temática que motiva a los estudiantes como
                ninguna otra:
              </p>
              <p className="text-brand-pink font-black text-xl sm:text-2xl mt-2" data-id="element-104">
                EL MUNDIAL 2026
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 9. BONUS SECTION */}
        <section className="text-center mb-12" data-id="element-105">
          <FadeIn data-id="element-106">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-4" data-id="element-107">
              Además recibís estos BONUS
            </h2>
            <div className="inline-block bg-brand-pink text-white px-4 py-1 rounded-full text-sm font-bold mb-10 uppercase tracking-wide" data-id="element-108">
              🎁 GRATIS POR TIEMPO LIMITADO
            </div>

            <div className="space-y-12 max-w-sm mx-auto" data-id="element-109">
              {/* Bonus 1 - 48 Países */}
              <div data-id="element-110">
                <div className="mb-3" data-id="element-111">
                  <img src="https://cdn.magicpatterns.com/uploads/9m5oB3CWx4n81jM38j6DDS/1_bonus.png" alt="Los 48 Países del Mundial 2026" className="w-full object-contain rounded-xl" data-id="element-112" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-113">
                  BONUS 1 — Los 48 Países del Mundial 2026
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-114">
                  48 fichas completas. Una por cada selección, con información,
                  comprensión, observación y actividades.
                </p>
              </div>

              {/* Bonus 2 - Primer Ciclo Extra */}
              <div data-id="element-115">
                <div className="mb-3" data-id="element-116">
                  <img src="https://cdn.magicpatterns.com/uploads/j6UZGKydnCQwG6GPt1sRrn/2_bonus.png" alt="Actividades Extra Primer Ciclo" className="w-full object-contain rounded-xl" data-id="element-117" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-118">
                  BONUS 2 — Actividades Extra para Primer Ciclo
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-119">
                  Más actividades para 1°, 2° y 3° grado. Juegos, desafíos y
                  propuestas complementarias.
                </p>
              </div>

              {/* Bonus 3 - Segundo Ciclo Extra */}
              <div data-id="element-120">
                <div className="mb-3" data-id="element-121">
                  <img src="https://cdn.magicpatterns.com/uploads/5QtSFAXvkrt4aMw5bdxXyz/3_bonus.png" alt="Actividades Extra Segundo Ciclo" className="w-full object-contain rounded-xl" data-id="element-122" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-123">
                  BONUS 3 — Actividades Extra para Segundo Ciclo
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-124">
                  Propuestas más avanzadas. Investigación, geografía,
                  estadísticas y comprensión.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 8. ANTES VS DESPUÉS */}
        <section className="mb-12" data-id="element-125">
          <FadeIn data-id="element-126">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-127">
              {/* Antes */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-200 text-center" data-id="element-128">
                <h3 className="text-xl font-bold text-brand-gray mb-6" data-id="element-129">
                  Antes del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-130">
                  {['Buscar actividades por todos lados', 'Adaptar material constantemente', 'Perder horas planificando', 'Improvisar propuestas', 'No encontrar recursos completos'].map((item, i) => <li key={i} className="flex items-start text-brand-gray font-medium" data-id="element-131">
                      <span className="mr-3 font-bold text-brand-red text-xl" data-id="element-132">
                        •
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Después */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 border-2 border-brand-lightBlue text-center" data-id="element-133">
                <h3 className="text-xl font-bold text-brand-pink mb-6" data-id="element-134">
                  Después del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-135">
                  {['Material listo para imprimir', 'Actividades organizadas', 'Diferentes niveles', 'Contenidos curriculares reales', 'Menos tiempo planificando', 'Más tiempo enseñando'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold" data-id="element-136">
                      <span className="mr-3 text-green-500 text-xl" data-id="element-137">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* CTA */}
        <section className="text-center mb-12" data-id="element-138">
          <FadeIn data-id="element-139">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-140">
              Accedé ahora al sistema completo para trabajar el Mundial 2026
            </h2>
            <Button onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-141">
              👉 QUIERO EL MEGAPACK MUNDIAL 2026
            </Button>
          </FadeIn>
        </section>
      </div>

      {/* 13. PRECIO SECTION - DARK BG */}
      <section id="compra" className="scroll-mt-10" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-144">
            <div className="max-w-3xl mx-auto text-center" data-id="element-145">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-4" data-id="element-146">
                Megapack Mundial 2026
              </h2>
              <p className="text-white font-bold text-lg sm:text-xl mt-2 mb-10 max-w-xl mx-auto" data-id="element-147">
                Todo el material que necesitás
              </p>

              <div className="max-w-2xl mx-auto mb-10" data-id="element-148">
                <img src="https://cdn.magicpatterns.com/uploads/iN3v9qG2kic5HxeUHJqiJh/imagen_principal.png" alt="Megapack Mundial 2026 - Todo el material" className="w-full" data-id="element-149" />
              </div>

              {/* Two plan cards */}
              <div className="grid md:grid-cols-2 gap-6 lg:gap-5 max-w-3xl mx-auto mb-10 items-stretch" data-id="element-150">
                {/* PLAN 1 - MEGAPACK MUNDIAL 2026 */}
                <div className="bg-[#0f1b33] rounded-3xl p-6 sm:p-7 flex flex-col text-left border border-white/10" data-id="element-151">
                  <div className="inline-block self-start bg-white/10 text-gray-200 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4" data-id="element-152">
                    MEGAPACK MUNDIAL 2026
                  </div>
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-3 leading-tight" data-id="element-153">
                    Todo el material del Mundial
                  </h3>
                  <ul className="space-y-2 mb-6 text-sm" data-id="element-154">
                    {['Rumbo al Mundial 2026 — Primer Ciclo', 'Rumbo al Mundial 2026 — Segundo Ciclo', 'Bonus especial de Inclusión', 'Pack Mundial para Docentes', 'Bonus: Los 48 países del Mundial', 'Bonus: Actividades extra Primer Ciclo', 'Bonus: Actividades extra Segundo Ciclo'].map((item, i) => <li key={i} className="flex items-start text-gray-200" data-id="element-155">
                        <span className="mr-2 text-green-400 text-base" data-id="element-156">✓</span>
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto" data-id="element-157">
                    <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-158">
                      ARS $11.990
                    </div>
                    <p className="text-[11px] text-gray-400 mb-5" data-id="element-159">
                      Pago único · Acceso de por vida
                    </p>
                    <Button className="w-full" href="https://checkout.aula-mater.online/cart/66808508153901:1" data-id="element-160">
                      👉 LO QUIERO
                    </Button>
                  </div>
                </div>

                {/* PLAN 2 - MEGAPACK + EFEMÉRIDES (FEATURED) */}
                <div className="bg-gradient-to-b from-brand-pink to-brand-darkPink rounded-3xl p-6 sm:p-7 flex flex-col text-left border-2 border-brand-pink relative shadow-2xl shadow-brand-pink/30 md:scale-105 md:-my-2" data-id="element-161">
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-brand-navy px-4 py-1 rounded-full text-xs font-black uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-162">
                    ⭐ MÁS ELEGIDO
                  </div>
                  <div className="inline-block self-start bg-white/20 text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4 mt-2" data-id="element-163">
                    MUNDIAL + EFEMÉRIDES
                  </div>
                  <h3 className="text-white font-black text-xl sm:text-2xl mb-3 leading-tight" data-id="element-164">
                    Megapack Mundial 2026 + Pack Efemérides Listas
                  </h3>
                  <ul className="space-y-2 mb-6 text-sm" data-id="element-165">
                    {['Todo el Megapack Mundial 2026', 'Pack Efemérides Listas completo', 'Recursos para todo el año', 'Mayor ahorro'].map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-166">
                        <span className="mr-2 text-yellow-300 text-base font-bold" data-id="element-167">
                          ✓
                        </span>
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto" data-id="element-168">
                    <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-169">
                      ARS $19.990
                    </div>
                    <p className="text-[11px] text-yellow-200 font-bold mb-5" data-id="element-170">
                      Pago único · Acceso de por vida
                    </p>
                    <a href="https://checkout.aula-mater.online/cart/44801847558189:1" className="inline-flex items-center justify-center w-full px-6 py-4 text-base sm:text-lg font-black text-brand-pink bg-white rounded-xl hover:bg-yellow-50 shadow-md hover:shadow-lg transition-all uppercase tracking-wide" data-id="element-171">
                      👉 LO QUIERO
                    </a>
                    <p className="mt-3 text-[10px] font-[500] text-white/80 text-center" data-id="element-172">
                      Tarjeta · Mercado Pago
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-[#0f1b33] rounded-3xl p-8 sm:p-10 max-w-xl mx-auto" data-id="element-173">
                <a href="https://wa.me/5491124676057?text=Hola%20vi%20el%20Megapack%20Mundial%202026%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-white transition-colors duration-200 bg-brand-pink rounded-xl hover:bg-brand-darkPink shadow-md hover:shadow-lg mb-4" data-id="element-174">
                  <span className="text-center" data-id="element-175">
                    <svg className="w-5 h-5 inline-block align-middle mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-176">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-177" />
                    </svg>
                    COMPRA POR WHATSAPP
                  </span>
                </a>

                <p className="text-[10px] font-[500] text-[#35C8C8] whitespace-nowrap" data-id="element-178">
                  Compra por Transferencia
                </p>

                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-white text-sm sm:text-base font-medium mt-8" data-id="element-179">
                  <div data-id="element-180">
                    <span className="text-green-400" data-id="element-181">✔</span> para todos los
                    niveles
                  </div>
                  <div data-id="element-182">
                    <span className="text-green-400" data-id="element-183">✔</span> acceso inmediato
                  </div>
                  <div data-id="element-184">
                    <span className="text-green-400" data-id="element-185">✔</span> descarga digital
                  </div>
                  <div data-id="element-186">
                    <span className="text-green-400" data-id="element-187">✔</span> material listo
                    para imprimir
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* CRÉDITO */}
      <div className="text-center py-8 px-4" data-id="element-188">
        <p className="text-brand-gray text-sm italic" data-id="element-189">
          Creado por{' '}
          <span className="font-bold text-brand-navy" data-id="element-190">Aula Mater</span>,
          proyecto educativo enfocado en facilitar el trabajo docente
        </p>
      </div>

      {/* 14. GARANTÍA */}
      <section className="text-center py-12 px-4" data-id="element-191">
        <FadeIn data-id="element-192">
          <div className="max-w-xl mx-auto" data-id="element-193">
            <img src="https://cdn.magicpatterns.com/uploads/c1WiiD5wweFWiSecTG8bGZ/pasted-image.jpg" alt="Garantía 7 días" className="w-28 h-28 mx-auto mb-4 object-contain" data-id="element-194" />
            <h2 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4" data-id="element-195">
              Garantía de satisfacción de 7 días
            </h2>
            <div className="space-y-3 text-brand-navy" data-id="element-196">
              <p className="font-semibold" data-id="element-197">
                Queremos que estés 100% conforme con tu compra.
              </p>
              <p data-id="element-198">
                Probalo sin riesgo. Si no te resulta útil, podés pedir la
                devolución.
              </p>
              <p className="font-bold text-brand-pink" data-id="element-199">
                Comprá con total tranquilidad: tu inversión está protegida.
              </p>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* FOOTER */}
      <footer className="bg-black py-8 px-4" data-id="element-200">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-201">
          <p className="text-white text-sm font-medium" data-id="element-202">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed max-w-lg mx-auto" data-id="element-203">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}